module.exports = __webpack_public_path__ + "static/media/send-invititation.dabdfc24.svg";